<div *ngIf="visible" class="dialog full-height modal-content">
  <div class="modal-header text-left">
    <button id="modalCloseIcon" *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn close">&times;</button>
    <h3>{{item ? item.title : ""}}</h3>
  </div>
  <div class="dialog-iframe-container">
    <img id="iframe-loader" app-sts-cms-image bypass="true" default="/tools/ariel-sts-app/{#clientCode#}/app/assets/images/backgrounds/Loading.gif" width="150" height="80" alt="loading gif" />
    <ng-container *ngIf="htmlContent !== null">
      <div [innerHTML]="htmlContent" class="dialog-iframe"></div>
    </ng-container>
    <ng-content></ng-content>
  </div>
  <div class="modal-footer">
    <button type="button" id="modalClose" class="btn btn-primary" (click)="close()" app-sts-cms-txt key="sts-close">{{ 'Close' }}</button>
  </div>
</div>
<div *ngIf="visible" class="overlay" (click)="close()"></div>
